'use client';

import type { RefObject, SyntheticEvent } from 'react';
import type { Crop, PixelCrop} from 'react-image-crop';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';

type Props = {
  src: string;
  aspect: number;
};

type BaseProps = {
  crop: Crop | undefined;
  setCrop: (crop: Crop) => void;
  completedCrop: PixelCrop | undefined;
  setCompletedCrop: (crop: PixelCrop) => void;
  imgRef: RefObject<HTMLImageElement | null>;
};

export const ImageCrop = (props: Props & BaseProps) => {
  const { aspect, src, crop, setCrop, setCompletedCrop, imgRef } = props;

  function onImageLoad(e: SyntheticEvent<HTMLImageElement, Event>) {
    const { naturalWidth: width, naturalHeight: height } = e.currentTarget;

    const crop = centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 100,
        },
        aspect,
        width,
        height,
      ),
      width,
      height,
    );

    setCrop(crop);
  }

  return (
    <ReactCrop
      crop={crop}
      onChange={(_, percentCrop) => setCrop(percentCrop)}
      onComplete={(c) => setCompletedCrop(c)}
      aspect={aspect}
      ruleOfThirds
    >
      <img ref={imgRef} alt="img" onLoad={onImageLoad} src={src} />
    </ReactCrop>
  );
};
